import moment from 'moment';

export class SystemApi {
    constructor(client) {
        this.client = client;
    }

    async list(siteID) {
        try {
            const systems = await this.client.get('/api/Systems?siteId=' + siteID, {
                anonymous: true
            });

            if(Array.isArray(systems)){
                if(systems.length > 0){
                    for(var i = 0; i < systems.length; i++){
                        var system = await this.getSystem(systems[i].id);
                        systems[i].workOrderTypes = [];
                        var allWorkOrders = system.system.workOrders;


                        if(allWorkOrders.length > 0){
                            var workOrders = allWorkOrders.slice();
            
                            workOrders.sort(function(a,b){
                                return new Date(a.visitDate) - new Date(b.visitDate);
                            });
            
                            var nextWorkOrder = null;
                            for(var j = 0; j < workOrders.length; j++){
                                if(moment(workOrders[j].visitDate).isAfter(moment())){
                                    
                                    nextWorkOrder = workOrders[j];
                                    break;
                                }
                            }
            
                        
                            if(nextWorkOrder){
                                for(var k = 0; k < workOrders.length; k++){
                                    
                                    if(moment(workOrders[k].visitDate).format('YYYY-MM-DD') == moment(nextWorkOrder.visitDate).format('YYYY-MM-DD')){
                                        if(workOrders[k].type){
                                            systems[i].workOrderTypes.push({
                                                type: workOrders[k].type, 
                                                id: workOrders[k].id
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                return {
                    systems
                };
            }else{
                return {
                    systems:[]
                };
            }

            
        } catch (error) {
            return {
                systems:[]
            };
        }
    }

    async getSystem(id){
        const system = await this.client.get('/api/Pages/system/' + id, {
            anonymous: true
        });

        return {
            system
        }
    }

    async getSystemName(id){
        const system = await this.client.get('/api/Pages/system/' + id, {
            anonymous: true
        });

        return system.name;
    }

    async getSystemServiceContracts(systemID){
        const result = await this.client.get('/api/ServiceContracts/Systems/' + systemID, {
            anonymous: true
        });
        return result;
    }

    async getSystemWorkOrders(systemID){
        const result = await this.client.get('/api/WorkOrders?systemId=' + systemID, {
            anonymous: true
        });
        return result;
    }
}